import AuthorizeTokenView from "./AuthorizeTokenView";

export default AuthorizeTokenView;